export default "__VITE_ASSET__DVTUXMN0__"